import MarketplaceItemMoreItemsList from './MarketplaceItemMoreItemsList'

export default MarketplaceItemMoreItemsList
